import { get, set } from './common';
var CampaignDialogCheckedKey = 'campaignDialogChecked:typica';
export var setCampaignDialogChecked = function (campaignDialogChecked) {
    set("".concat(CampaignDialogCheckedKey), campaignDialogChecked);
};
export var getCampaignDialogChecked = function () {
    return get("".concat(CampaignDialogCheckedKey));
};
